import React from "react";

function NoMatch() {
  return <h1>Error 404: Page not found</h1>;
}

export default NoMatch;
